module.exports = __webpack_public_path__ + "media/assets/icons/ic-lifebuoy-3504a009a93d525b1a51d3d8e2eb701a.svg";